export const getOrderTotalNumeric = state => state.orderSummary.orderTotalNumeric || state.orderSummary.orderTotal.value;
